import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RestrictLabel } from 'fitforce-document-sync';

@Component({
  selector: 'app-add-restriction-dialog',
  templateUrl: './add-restriction-dialog.component.html',
  styleUrls: ['./add-restriction-dialog.component.scss'],
})
export class AddRestrictionDialogComponent implements OnInit {
  filteredData: RestrictLabel[];
  selectedLabel: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: RestrictLabel[]) {}

  ngOnInit() {
    this.filteredData = this.data.slice();
  }

  filter(label: string) {
    if (!label) {
      this.filteredData = this.data.slice();
    } else {
      this.filteredData = this.data.filter(restrictionLabel => restrictionLabel.name.toLowerCase().indexOf(label.toLowerCase()) > -1);
    }
  }
}
